// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DotBgBtn_wrap_3TWaV","bg":"DotBgBtn_bg_2xk3j","flashColors":"DotBgBtn_flashColors_rV-lq","main":"DotBgBtn_main_306Xa","main_enquete":"DotBgBtn_main_enquete_JLd4e"};